import React from "react";

export const ShareTypePill = ({ shareType, active = true, onClick, size = "md" }) => {
  const sizes = { sm: "px-2 py-0.5 text-[11px]", md: "px-3 py-1.5 text-sm" };
  const isVoting = shareType === "voting";
  const label = isVoting ? "Voting" : "Non-voting";
  const suffix = isVoting ? ".N0000" : ".X0000";
  const cls = active
    ? "bg-primary text-primary-foreground"
    : "bg-muted text-foreground hover:bg-muted/70";
  const inner = (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium transition-colors duration-150 ${sizes[size]} ${cls}`}>
      {label} <span className="font-mono opacity-80">{suffix}</span>
    </span>
  );
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid={isVoting ? "share-type-voting-pill" : "share-type-nonvoting-pill"}
      >
        {inner}
      </button>
    );
  }
  return inner;
};

export default ShareTypePill;
